import AuthService from "../../utilities/services/auth.service";

import { DailyTicketsCountReportWrapper } from "../../components";

export default function DailyTicketsCountReportPage() {
  const organization = AuthService.getOrg()[0];

  return (
    <>
      <DailyTicketsCountReportWrapper organization={organization} />
    </>
  );
}
